import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PORTFOLIO } from "../../data/business";

const FEATURED_PORTFOLIO_COUNT = 6;

export default function PortfolioSection() {
  return (
    <section className="py-12 md:py-16 abc-bg-pale" data-testid="home-portfolio">
      <div className="abc-container">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <div className="text-xs font-bold uppercase tracking-widest text-[#54616E] mb-3">Recent work</div>
            <h2 className="font-display text-3xl sm:text-4xl font-extrabold text-[#1A1D21]">Real jobs, real homes</h2>
          </div>
          <Link to="/gallery" className="abc-btn abc-btn-outline" data-testid="home-view-gallery">
            See gallery <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PORTFOLIO.slice(0, FEATURED_PORTFOLIO_COUNT).map((p) => (
            <div key={p.title} className="abc-card overflow-hidden group" data-testid={`portfolio-${p.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <div className="aspect-[4/3] overflow-hidden">
                <img src={p.image} alt={p.title} loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
              </div>
              <div className="p-5">
                <div className="text-xs font-semibold text-[#54616E] uppercase tracking-wider">{p.category}</div>
                <h3 className="font-display font-bold text-[#1A1D21] mt-1">{p.title}</h3>
                <p className="text-sm text-slate-500 mt-1">{p.city}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
